import React from "react";

const LOGOS = [
  { src: "/logos/visa.svg", alt: "Visa" },
  { src: "/logos/mastercard.svg", alt: "Mastercard" },
  { src: "/logos/cb.svg", alt: "CB" },
  { src: "/logos/amex.svg", alt: "American Express" },
  { src: "/logos/paypal.svg", alt: "PayPal" },
  { src: "/logos/oney.svg", alt: "Oney" },
  { src: "/logos/chronopost.svg", alt: "Chronopost" },
  { src: "/logos/dhl.svg", alt: "DHL" },
  { src: "/logos/ups.svg", alt: "UPS" },
  { src: "/logos/gls.svg", alt: "GLS" },
];

const LogoItem = ({ src, alt }) => (
  <div className="partner-chip" data-testid={`partner-logo-${alt.toLowerCase().replace(/\s+/g, "-")}`}>
    <img src={src} alt={alt} loading="lazy" />
  </div>
);

const PartnerBanner = () => {
  const loop = [...LOGOS, ...LOGOS];
  return (
    <section className="partner-banner" data-testid="partner-banner" aria-label="Moyens de paiement et transporteurs">
      <div className="marquee">
        <div className="marquee-track">
          {loop.map((l, i) => (
            <LogoItem key={`${l.alt}-${i}`} {...l} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnerBanner;
